<div class="grid grid-liquid mobile-policy">
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-claim-small" class="xsmall"></open-svg-icon>
      <h2>Cover</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Start</span>
        <span class="stat-block-value">{{ policyDetails.startDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">End</span>
        <span class="stat-block-value">{{ policyDetails.endDate | displayDate }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Payment frequency</span>
        <span class="stat-block-value">{{ policyDetails.paymentFrequency.label }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block" *ngIf="policyDetails.firstPayableInvoice.amount">
        <span class="stat-block-title">First payment</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.firstPayableInvoice" size="inherit"></open-price></span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">{{ policyDetails.isUpfront ? 'Premium' : 'Ongoing monthly payment' }}</span>
        <span class="stat-block-value"><open-price [price]="policyDetails.premium" size="inherit"></open-price></span>
      </div>
      <div class="cell cell-large-col-span-8 flex flex-column stat-block">
        <span class="stat-block-title">Excess</span>
        <span class="stat-block-value margin-bottom-xxsmall">Accidental Damage: <open-price [price]="policyDetails.excessDamage" [precision]="0" size="inherit"></open-price></span>
        <span class="stat-block-value margin-bottom-xxsmall">Breakdown: <open-price [price]="policyDetails.excessBreakdown" [precision]="0" size="inherit"></open-price></span>
        <span class="stat-block-value margin-bottom-xxsmall" *ngIf="policyDetails.excessTheft">Theft: <open-price [price]="policyDetails.excessTheft" [precision]="0" size="inherit"></open-price></span>
        <span class="stat-block-value" *ngIf="policyDetails.excessLoss">Loss: <open-price [price]="policyDetails.excessLoss" [precision]="0" size="inherit"></open-price></span>
        <div class="open-form-info padding-small margin-top-small" *ngIf="!policyDetails.deviceVerified">
          <span class="text-small">Your excess will be higher until you have successfully validated your phone using our Condition Check. Visit <a *ngIf="faq.url" [href]="faq.url" color="primary">{{ faq.label }}</a><span *ngIf="!faq.url">our faqs</span> to find out how to validate your phone.</span>
        </div>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="marketing-optionals" class="xsmall"></open-svg-icon>
      <h2>Device</h2>
    </div>
    <div class="grid grid-large-8">
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Model</span>
        <span class="stat-block-value">{{ policyDetails.deviceModel }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">IMEI</span>
        <span class="stat-block-value">{{ policyDetails.deviceImei }}</span>
      </div>
      <div class="cell cell-large-col-span-4 flex flex-column stat-block">
        <span class="stat-block-title">Phone validated</span>
        <span class="stat-block-value">{{ policyDetails.deviceVerified ? 'Yes' : 'No' }}</span>
      </div>
    </div>
  </div>
  <div class="cell cell-medium-col-span-8 cell-large-col-span-6 padding-medium info-box">
    <div class="cell cell-large-col-span-12 flex flex-items-center info-box-header">
      <open-svg-icon name="management-authoriseddrivers-small" class="xsmall"></open-svg-icon>
      <h2>Authorised contact</h2>
    </div>
    <div class="cell cell-large-col-span-8 flex flex-column stat-block">
      <span class="stat-block-title">Authorised contact</span>
      <div class="grid grid-large-8 margin-none">
        <div class="cell cell-large-col-span-4 flex flex-column">
          <span class="stat-block-value">{{ policyDetails.policyHolder.givenName }} {{ policyDetails.policyHolder.lastName }}</span>
          <span class="stat-block-desc">{{ policyDetails.policyHolder.dob | age }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
